import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ProgressStep } from 'motion-master-client';

import { MotionPreventedTooltipDirective } from '@app/shared/motion-prevented-tooltip.directive';

@Component({
  selector: 'app-progress-steps',
  templateUrl: './progress-steps.component.html',
  imports: [NgClass, NgbTooltip, MotionPreventedTooltipDirective],
})
export class ProgressStepsComponent<T extends ProgressStep<any>> {
  @Input()
  progressSteps: T[] = [];

  @Input()
  isRunning: boolean;

  @Input()
  showActions = true;

  @Input()
  disabled: boolean;

  @Output()
  run = new EventEmitter<T>();
}
